function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 31",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--icon-color, currentColor)"
    },
    d: "M15.1491 1.26415C15.5076 0.547197 16.0852 0.188721 16.8818 0.188721C17.6784 0.188721 18.2559 0.547197 18.6144 1.26415L22.4979 9.15063L31.2208 10.465C32.0175 10.5447 32.5352 10.9629 32.7742 11.7197C33.0132 12.4765 32.8539 13.1337 32.2963 13.6913L25.9632 19.8452L27.4568 28.5681C27.5763 29.3249 27.3174 29.9224 26.6801 30.3605C26.0428 30.8385 25.3856 30.8982 24.7085 30.5397L16.8818 26.477L9.05504 30.5397C8.37792 30.938 7.72071 30.8982 7.08342 30.4202C6.44613 29.9423 6.18723 29.3249 6.30672 28.5681L7.80037 19.8452L1.46729 13.6913C0.909656 13.1337 0.750334 12.4765 0.989318 11.7197C1.2283 10.9629 1.7461 10.5447 2.54272 10.465L11.2656 9.15063L15.1491 1.26415Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSolid);
export default __webpack_public_path__ + "static/media/star-solid.b59871da34892fc38d9c4b7e943e4200.svg";
export { ForwardRef as ReactComponent };